import React, { useState } from 'react';
import { Space, Typography, DatePicker } from 'antd';
import { Button, Message } from '@alifd/next';
import moment from 'moment';
import locale from 'antd/es/date-picker/locale/zh_TW';
import { downloadSheet } from './util';

export default function DownloadAnnualReport() {
  const [months, setMonths] = useState([moment(), moment()]);

  const handleDownload = () => {
    if (months) {
      downloadSheet(
        `/ezcon/api/downloadFinancialYearlyExcel?timeStart=${months[0].valueOf()}&timeEnd=${months[1].valueOf()}`,
        `${months[0].format('YYYYMM')}-${months[1].format(
          'YYYYMM'
        )}財務收支表.xlsx`
      );
    } else {
      Message.error('請選擇開始與結束月份');
    }
  };

  return (
    <Space>
      <div>
        <Typography.Text>財務收支表包含月份：</Typography.Text>
        <DatePicker.RangePicker
          picker="month"
          value={months}
          onChange={(value) => setMonths(value)}
          locale={locale}
          disabledDate={(current) => current && current > moment().endOf('day')}
        />
      </div>
      <Button onClick={handleDownload}>下載</Button>
    </Space>
  );
}
